
import uxColWidthForItemsPerRow from '../../lib/uxColWidthForItemsPerRow';

const servicesList = [
  // ... first row
  [
    // ... 4 services per row
    [
      'web_development',
      'Web Development',
      'Full stack: from nothing to deployment',
      'globe',
      'Ruby on Rails, React, etc.'
    ],

    [
      'api_development',
      'API Development',
      'Everything back end',
      'server',
      'RoR API, Elixr/Phoenix, Go, etc.'
    ],

    [
      'front_end',
      'Front End Development',
      'Responsive and mobile-friendly design',
      //  using HTML, CSS, JavaScript, React',
      // Bootstrap Semantic UI
      'mobile',
      'HTML, CSS, JavaScript, React, etc.'
    ],

    [
      'linux',
      'DevOps / Automation',
      'Everything Linux: system administration and automation',
      //  using Ansible, bash, etc.',
      'linux',
      'bash, git, tcpdump, etc.'
    ],
  ],

  // ... 2nd row
  [
    [
      'data_extraction',
      'Data Extraction',
      'Automated data extraction/bot scripting with or without an API (if the target site allows it)',
      'industry',
      '...'
    ],

    [
      'ux_design_replication',
      'UX Design or Theme Replication',
      'Any design you like I can replicate for you',
      'copy',
      '...'
    ]
  ]
].map(row => row.map(serviceData => {
  return ['name', 'title', 'description', 'icon', 'tools'].reduce((acc, key, ix) => {
    acc[key] = serviceData[ix];
    return acc;
  }, {});
}));

export default (uxMaxColumnsPerRow) => ({
  list: servicesList,
  uxColumnWidthPerItem: uxColWidthForItemsPerRow(
    uxMaxColumnsPerRow, servicesList
  )
});



// WEBPACK FOOTER //
// ./src/components/services/services.js